import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useToastNotify() {
  return {
    toastNotify: GlobalPrototypes.toastNotify,
  }
}
